import { PlayerAhoyEvent } from '../player_ahoy_event';
import isFeatureToggleOn from "@javascripts/utils/feature_toggle";
import BannerAdTracker from './banner_ad_tracker';

export default class Overlay {
  constructor(options = {}){
    this._tech = options.tech;
    this._data = options.data;
    this._showing = false;
    this._isGoogleTagDisplayCalled = false;
    this._container = null;
    this.playerDisplayAdState = options.playerDisplayAdState
  }

  tech() {
    return this._tech;
  }
 
  data() {
    return this._data;
  }

  showing() {
    return this._showing;
  }

  container() {
    return this._container;
  }

  firstRenderTime() {
    return this.data().overlayFirstRenderTime() * 1000;
  }

  refreshInterval() {
    return this.data().overlayRefreshInterval() * 1000;
  }

  autohideInterval() {
    return 20000
  }

  get name() {
    return 'overlay'
  }

  show(options) {
    if (!this.showing()) {
      this._showing = true;
      this.initOverlay();
    }
  }

  hide() {
    this._showing = false;

    if (this.container()) {
      this.container().style.visibility = "hidden";
      
      const closeBtn = this.container().querySelector('.overlay-ad-close');
      if (closeBtn) {
        closeBtn.parentElement.removeChild(closeBtn);
      }
    }
  }

  isReady() {
    return this.shouldInitOverlay() && this.shouldTriggerOverlayAd();
  }

  initOverlay() {
    if (this.shouldInitOverlay()) {
      if(!this.container()) {
        this._container = this.createOverlayAdContainer();
        this.tech().el().appendChild(this.container());
      }
      this.triggerOverlayAd();
    }
  }

  shouldInitOverlay() {
    return this.data().overlayAdDomId() != "";
  }

  createOverlayAdContainer() {
    const container = document.createElement('div');
    container.id = 'overlayAdContainer'
    container.className = 'overlay-ad-container';
    container.style.visibility = "hidden";

    container.appendChild(this.createOverlayAd());

    return container;
  }

  createOverlayAd() {
    const overlayAd = document.createElement('div');
    overlayAd.id = this.data().overlayAdDomId();
    overlayAd.className = 'overlay-ad'
    return overlayAd;
  }

  triggerOverlayAd() {
    if (this.shouldTriggerOverlayAd()) {
      if (this._isGoogleTagDisplayCalled) {
        window.googletag.cmd.push(this.refreshAd());
      } else {
        window.googletag.cmd.push(this.displayAd());
        this._isGoogleTagDisplayCalled = true;
      }
    } else {
      this._showing = false;
    }
  }
  
  shouldTriggerOverlayAd() {
    return (
      !this.isEmbedAndPlayerWidthBelow300() &&
      this.isBannerAdForPremierUserToggledOnOrContentNotPremium() &&
      this.isGPTConfigured() &&
      this.isPlayerInViewport()
    )
  }

  showOverlayAd() {
    setTimeout(() => {
      this.container().style.visibility = "";
    }, 300);
  }

  isEmbedAndPlayerWidthBelow300() {
    return this.data().embed() === 'true' && this.tech().el().clientWidth() <= 300
  }

  isBannerAdForPremierUserToggledOnOrContentNotPremium() {
    return isFeatureToggleOn('enable_premier_user_banner_ads') || !this.data().isPremier()
  }

  isGPTConfigured() {
    return !!(
      window.googletag &&
      window.googletag.apiReady &&
      window.googletag.pubadsReady &&
      window.kmklabs &&
      window.kmklabs.gpt &&
      window.kmklabs.gpt.overlay_ad
    )
  }

  isPlayerInViewport() {
    const rect = this.tech().videoElement()?.getBoundingClientRect()

    return rect != null && rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  }

  displayAd() {
    return function() {
      window.googletag.display(window.kmklabs.gpt.overlay_ad);
    }
  }

  refreshAd() {
    return function() {
      window.googletag.pubads().refresh([window.kmklabs.gpt.overlay_ad]);
    };
  }

  appendCloseButton() {
    setTimeout(() => {
      if (this.container()) {
        this.container().appendChild(this.closeButton())
      }
    }, 5000);
  }

  onCloseButtonClick(e) {
    BannerAdTracker.sendEvent({ ad_event: 'CLOSE', uuid: this.data().playUUID() })
    e.stopPropagation();
    this.hide();
  }

  closeButton() {
    if (typeof this._closeButton == "undefined") {
      const closeButton = document.createElement("a");
      closeButton.className = "overlay-ad-close";

      closeButton.onclick = this.onCloseButtonClick.bind(this);

      this._closeButton = closeButton;
    }
    return this._closeButton;
  }
}
